<p-dialog #dialog appendTo="body" [header]="header" [(visible)]="visible" [modal]="true"
  [style]="{'width': '1000px', 'height': '620px'}" [contentStyle]="{'overflow': 'hidden'}"
  [resizable]="false" (onHide)="hide()">

  <span class="col-lg-4" style="float: right; z-index: 1000; position: relative;">
    <label style="margin-right: 5px;">Device Filter:</label>
    <select (change)="onSelectedFilterChange($event)">
      @for (fe of filterEntries; track fe) {
        <option value="{{fe.index}}"
          [attr.selected]="(fe.name === defaultFilter) ? '' : null">
          {{fe.name}}
        </option>
      }
    </select>
  </span>

  <p-tabView #tabview [(activeIndex)]="activeTabIndex" (activeIndexChange)="onActiveIndexChange($event)">
    <p-tabPanel header="Monitored Devices" headerStyleClass="monitored-header" [selected]="true">

      @if (monDevicesLoading && monitorEntries.length == 0) {
        <div>
          Loading devices ...
        </div>
      }

      @if (!monDevicesLoading && monitorEntries.length == 0) {
        <div>
          No devices ...
        </div>
      }

      @if (monitorEntries.length > 0) {
        <div>
          <uv-table #montable class="monitor-devices-table" [columns]="monitorCols" [value]="monitorEntries"
            dataKey="dataKey" [resizableColumns]="true" [(first)]="monitoredFirst"
            [scrollable]="true" scrollHeight="calc(390px)"
            [customSort]="true" (sortFunction)="doCustomSort($event, monitorEntries)"
            [(selection)]="selectedMonitorDevices" (onFilter)="onMonitorFilterChange()"
            [virtualScroll]="true" [virtualScrollItemSize]="VirtualScrollItemSize">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th class="uv-table-checkbox">
                  <uv-tableHeaderCheckbox></uv-tableHeaderCheckbox>
                </th>
                @for (col of columns; track col) {
                  <th uvResizableColumn [uvSortableColumn]="col.field">
                    {{col.header}}
                    <uv-sortIcon [field]="col.field"></uv-sortIcon>
                  </th>
                }
              </tr>
              <tr>
                <th class="uv-table-checkbox"></th>
                @for (col of columns; track col) {
                  <th>
                    <input #monfilter pInputText type="text" style="width: 100%;"
                      (input)="montable.filter($event.target.value, col.field, col.filterMatchMode)">
                    </th>
                  }
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr [style]="TableRowStyle" [uvSelectableRow]="rowData">
                  <td class="uv-table-checkbox">
                    <uv-tableCheckbox [value]="rowData"></uv-tableCheckbox>
                  </td>
                  @for (col of columns; track col) {
                    <td>
                      <span class="uv-table-value">{{rowData[col.field]}}</span>
                    </td>
                  }
                </tr>
              </ng-template>
            </uv-table>
            <div class="row" style="margin-top: 3px;">
              <label class="col-lg-4">Total Monitored Devices: {{montable.totalRecords}}</label>
              <label class="col-lg-4">Selected Monitored Devices: {{selectedMonitorDeviceCount}}</label>
            </div>
          </div>
        }

      </p-tabPanel>

      <p-tabPanel header="Unmonitored Devices" headerStyleClass="unmonitored-header">

        @if (devicesLoading && entries.length == 0) {
          <div>
            Loading devices ...
          </div>
        }

        @if (!devicesLoading && entries.length == 0) {
          <div>
            No devices ...
          </div>
        }

        @if (entries.length > 0) {
          <div>
            <uv-table #table class="monitor-devices-table" [columns]="cols" [value]="entries" dataKey="dataKey"
              [resizableColumns]="true" [(first)]="unmonitoredFirst"
              [scrollable]="true" scrollHeight="calc(390px)"
              [customSort]="true" (sortFunction)="doCustomSort($event, entries)"
              [(selection)]="selectedDevices" (onFilter)="onFilterChange()"
              [virtualScroll]="true" [virtualScrollItemSize]="VirtualScrollItemSize">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th class="uv-table-checkbox">
                    <uv-tableHeaderCheckbox></uv-tableHeaderCheckbox>
                  </th>
                  @for (col of columns; track col) {
                    <th uvResizableColumn [uvSortableColumn]="col.field">
                      {{col.header}}
                      <uv-sortIcon [field]="col.field"></uv-sortIcon>
                    </th>
                  }
                </tr>
                <tr>
                  <th class="uv-table-checkbox"></th>
                  @for (col of columns; track col) {
                    <th>
                      <input #filter pInputText type="text" style="width: 100%;"
                        (input)="table.filter($event.target.value, col.field, col.filterMatchMode)">
                      </th>
                    }
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                  <tr [style]="TableRowStyle" [uvSelectableRow]="rowData">
                    <td class="uv-table-checkbox">
                      <uv-tableCheckbox [value]="rowData"></uv-tableCheckbox>
                    </td>
                    @for (col of columns; track col) {
                      <td>
                        <span class="uv-table-value">{{rowData[col.field]}}</span>
                      </td>
                    }
                  </tr>
                </ng-template>
              </uv-table>
              <div class="row" style="margin-top: 3px;">
                <label class="col-lg-4">Total Unmonitored Devices: {{table.totalRecords}}</label>
                <label class="col-lg-4">Selected Unmonitored Devices: {{selectedDeviceCount}}</label>
              </div>
            </div>
          }

        </p-tabPanel>
      </p-tabView>

      <div class="row" style="margin-top: 0px;">
        <span class="col-lg-6">&nbsp;</span>
        <label class="col-lg-3">Total Devices: {{overallTotalDeviceCount}}</label>
        <label class="col-lg-3">Selected Devices: {{overallSelectedDeviceCount}}</label>
      </div>

      <p-footer>
        <button type="button" pButton icon="fa fa-check" [disabled]="!isOkEnabled()"
        (click)="onOkClicked()" label="OK"></button>
        <button type="button" pButton icon="fa fa-times" [disabled]="false"
        (click)="onCancelClicked()" label="Cancel"></button>
      </p-footer>

    </p-dialog>